const STORAGE_KEY = "appearance";

export const loadAppearance = () => {
  try {
    const value = localStorage.getItem(STORAGE_KEY);

    if (!value) {
      return null;
    }

    return JSON.parse(value);
  } catch (error) {
    console.warn("Unable to load appearance settings.", error);
    return null;
  }
};

export const saveAppearance = (appearance) => {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(appearance)
    );
  } catch (error) {
    console.warn("Unable to save appearance settings.", error);
  }
};

export const clearAppearance = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn("Unable to clear appearance settings.", error);
  }
};